// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__V3mmY {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
}
@media (max-width: 768px) {
  .styles_wrapper__V3mmY {
    grid-template-columns: 1fr;
  }
}

.styles_checkboxBlock__NbQ76 {
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(3, 1fr);
  grid-column-start: 1;
  grid-column-end: 3;
}
@media (max-width: 768px) {
  .styles_checkboxBlock__NbQ76 {
    grid-template-columns: 1fr;
    grid-column-start: unset;
    grid-column-end: unset;
  }
}

.styles_checkboxWrapper__kwVy0:nth-child(2) {
  grid-column-start: 2;
}
@media (max-width: 992px) {
  .styles_checkboxWrapper__kwVy0:nth-child(2) {
    grid-column-start: 3;
  }
}
@media (max-width: 768px) {
  .styles_checkboxWrapper__kwVy0:nth-child(2) {
    grid-column-start: unset;
  }
}
.styles_checkboxWrapper__kwVy0:last-child {
  grid-column-start: 1;
  grid-column-end: 3;
}
@media (max-width: 768px) {
  .styles_checkboxWrapper__kwVy0:last-child {
    grid-column-start: unset;
    grid-column-end: unset;
  }
}

.styles_textWrapper__sW5wd {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.styles_text__J4LBy {
  font-weight: 300;
  font-size: 16px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}

.styles_subtext__6CBcM {
  font-weight: 300;
  font-size: 12px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}

.styles_link__yKxbH {
  font-weight: 300;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.015em;
  color: #ff136d;
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/baseContent/burningContent/featureInput/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AAFF;AC2BE;ED5BF;IAMI,0BAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,cAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AADF;ACcE;EDlBF;IAQI,0BAAA;IACA,wBAAA;IACA,sBAAA;EAAF;AACF;;AAIE;EACE,oBAAA;AADJ;ACHE;EDGA;IAII,oBAAA;EAAJ;AACF;ACFE;EDHA;IAQI,wBAAA;EACJ;AACF;AAEE;EACE,oBAAA;EACA,kBAAA;AAAJ;ACXE;EDSA;IAKI,wBAAA;IACA,sBAAA;EACJ;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BEtDS;AFsDX;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BEhES;AFgEX;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cEpEK;AFoEP","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 24px;\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.checkboxBlock {\n  display: grid;\n  grid-gap: 24px;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-start: 1;\n  grid-column-end: 3;\n\n  @include md {\n    grid-template-columns: 1fr;\n    grid-column-start: unset;\n    grid-column-end: unset;\n  }\n}\n\n.checkboxWrapper {\n  &:nth-child(2) {\n    grid-column-start: 2;\n\n    @include lg {\n      grid-column-start: 3;\n    }\n\n    @include md {\n      grid-column-start: unset;\n    }\n  }\n\n  &:last-child {\n    grid-column-start: 1;\n    grid-column-end: 3;\n\n    @include md {\n      grid-column-start: unset;\n      grid-column-end: unset;\n    }\n  }\n}\n\n.textWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.text {\n  font-weight: 300;\n  font-size: 16px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-80;\n}\n\n.subtext {\n  font-weight: 300;\n  font-size: 12px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n}\n\n.link {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: -0.015em;\n  color: $pink;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__V3mmY`,
	"checkboxBlock": `styles_checkboxBlock__NbQ76`,
	"checkboxWrapper": `styles_checkboxWrapper__kwVy0`,
	"textWrapper": `styles_textWrapper__sW5wd`,
	"text": `styles_text__J4LBy`,
	"subtext": `styles_subtext__6CBcM`,
	"link": `styles_link__yKxbH`
};
export default ___CSS_LOADER_EXPORT___;
